/**
 * enum for setting block alignment, used by setAlignment API
 */
// eslint-disable-next-line etc/no-const-enum
export var Alignment;
(function (Alignment) {
    /**
     * Align left
     */
    Alignment[Alignment["Left"] = 0] = "Left";
    /**
     * Align center
     */
    Alignment[Alignment["Center"] = 1] = "Center";
    /**
     * Align right
     */
    Alignment[Alignment["Right"] = 2] = "Right";
})(Alignment || (Alignment = {}));
//# sourceMappingURL=Alignment.js.map